import React from "react";

interface ResponsiveImageProps {
  src: string;
  alt: string;
  className?: string;
  sizes?: string;
  widths?: number[];
  lazy?: boolean;
  priority?: boolean;
}

const ResponsiveImage: React.FC<ResponsiveImageProps> = ({
  src,
  alt,
  className = "",
  sizes = "100vw",
  widths = [320, 640, 768, 1024, 1280],
  lazy = true,
  priority = false,
}) => {
  // Generate default srcSet if it's an image that can be resized
  const fileExtension = src.split('.').pop()?.toLowerCase();
  const isResizableImage = ['jpg', 'jpeg', 'png', 'webp'].includes(fileExtension || '');
  
  // For SVGs and other non-resizable formats, we don't need srcSet
  if (!isResizableImage) {
    return (
      <img
        src={src}
        alt={alt}
        className={className}
        loading={!priority && lazy ? "lazy" : undefined}
        fetchPriority={priority ? "high" : undefined}
      />
    );
  }

  // Generate srcSet for resizable images
  // For production, you would use a real image resizing service
  // This is just an example of the syntax
  const srcSet = widths
    .map((width) => {
      // In a real app, we'd use a properly resized image
      // This is just for demonstration
      return `${src} ${width}w`;
    })
    .join(", ");

  return (
    <img
      src={src}
      alt={alt}
      srcSet={srcSet}
      sizes={sizes}
      className={className}
      loading={!priority && lazy ? "lazy" : undefined}
      fetchPriority={priority ? "high" : undefined}
    />
  );
};

export default ResponsiveImage;
